var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _path14, _path15, _path16, _path17, _rect3, _path18, _path19, _path20, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSea05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.464844,
    y: 0.296875,
    width: 350,
    height: 233,
    fill: "#508D69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.865 107.301H247.436V163.871H201.865V107.301Z",
    fill: "#B66B25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.293 107.301H311.863V163.871H266.293V107.301Z",
    fill: "#B66B25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.705 101.883C218.705 99.6737 220.496 97.8828 222.705 97.8828H226.595C228.804 97.8828 230.595 99.6737 230.595 101.883V107.297H218.705V101.883Z",
    fill: "#B66B25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M283.133 101.883C283.133 99.6737 284.924 97.8828 287.133 97.8828H291.023C293.232 97.8828 295.023 99.6737 295.023 101.883V107.297H283.133V101.883Z",
    fill: "#B66B25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.865 101.883C201.865 99.6737 203.656 97.8828 205.865 97.8828H209.755C211.964 97.8828 213.755 99.6737 213.755 101.883V107.297H201.865V101.883Z",
    fill: "#B66B25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M299.973 101.883C299.973 99.6737 301.764 97.8828 303.973 97.8828H307.862C310.072 97.8828 311.862 99.6737 311.862 101.883V107.297H299.973V101.883Z",
    fill: "#B66B25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.195 107.301H244.766V163.871H199.195V107.301Z",
    fill: "#E9A363"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.623 107.301H309.194V163.871H263.623V107.301Z",
    fill: "#E9A363"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.035 101.883C216.035 99.6737 217.826 97.8828 220.035 97.8828H223.925C226.134 97.8828 227.925 99.6737 227.925 101.883V107.297H216.035V101.883Z",
    fill: "#E9A363"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280.463 101.883C280.463 99.6737 282.254 97.8828 284.463 97.8828H288.353C290.562 97.8828 292.353 99.6737 292.353 101.883V107.297H280.463V101.883Z",
    fill: "#E9A363"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.195 101.883C199.195 99.6737 200.986 97.8828 203.195 97.8828H207.085C209.294 97.8828 211.085 99.6737 211.085 101.883V107.297H199.195V101.883Z",
    fill: "#E9A363"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.303 101.883C297.303 99.6737 299.094 97.8828 301.303 97.8828H305.193C307.402 97.8828 309.193 99.6737 309.193 101.883V107.297H297.303V101.883Z",
    fill: "#E9A363"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.965 107.297H279.7V163.867H270.965V107.297Z",
    fill: "#E19752"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 233.207,
    y: 90.0977,
    width: 45.5705,
    height: 73.7667,
    fill: "#A3673C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.047 84.6836C250.047 82.4745 251.838 80.6836 254.047 80.6836H257.937C260.146 80.6836 261.937 82.4745 261.937 84.6836V90.0982H250.047V84.6836Z",
    fill: "#A3673C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233.207 84.6836C233.207 82.4745 234.998 80.6836 237.207 80.6836H241.097C243.306 80.6836 245.097 82.4745 245.097 84.6836V90.0982H233.207V84.6836Z",
    fill: "#A3673C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M266.889 84.6836C266.889 82.4745 268.68 80.6836 270.889 80.6836H274.779C276.988 80.6836 278.779 82.4745 278.779 84.6836V90.0982H266.889V84.6836Z",
    fill: "#A3673C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M228.838 107.297H237.573V163.867H228.838V107.297Z",
    fill: "#E19752"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 231.41,
    y: 90.0977,
    width: 45.5705,
    height: 73.7667,
    fill: "#EABF98"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M248.25 84.6836C248.25 82.4745 250.041 80.6836 252.25 80.6836H256.14C258.349 80.6836 260.14 82.4745 260.14 84.6836V90.0982H248.25V84.6836Z",
    fill: "#EABF98"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M231.41 84.6836C231.41 82.4745 233.201 80.6836 235.41 80.6836H239.3C241.509 80.6836 243.3 82.4745 243.3 84.6836V90.0982H231.41V84.6836Z",
    fill: "#EABF98"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265.092 84.6836C265.092 82.4745 266.883 80.6836 269.092 80.6836H272.982C275.191 80.6836 276.982 82.4745 276.982 84.6836V90.0982H265.092V84.6836Z",
    fill: "#EABF98"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_569_27330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.727,
    y: 104.926,
    width: 9.89336,
    height: 13.6914,
    rx: 4,
    fill: "#B77A41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_569_27330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.246,
    y: 104.926,
    width: 9.89336,
    height: 13.6914,
    rx: 4,
    fill: "#B77A41"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_569_27330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.623,
    y: 104.926,
    width: 9.89336,
    height: 13.6914,
    rx: 4,
    fill: "#B77A41"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_569_27330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.203 146.1C241.203 138.926 247.019 133.109 254.194 133.109V133.109C261.369 133.109 267.185 138.926 267.185 146.1V163.741C267.185 163.809 267.13 163.864 267.062 163.864H241.326C241.258 163.864 241.203 163.809 241.203 163.741V146.1Z",
    fill: "#B77A41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_569_27330",
    x: 235.727,
    y: 104.926,
    width: 9.99258,
    height: 13.7914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.403325 0 0 0 0 0.23375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27330"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_569_27330",
    x: 249.246,
    y: 104.926,
    width: 9.99258,
    height: 13.7914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.403325 0 0 0 0 0.23375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27330"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_569_27330",
    x: 263.623,
    y: 104.926,
    width: 9.99258,
    height: 13.7914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.403325 0 0 0 0 0.23375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27330"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_569_27330",
    x: 241.203,
    y: 133.109,
    width: 26.1824,
    height: 30.9539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.403922 0 0 0 0 0.235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27330"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea05);
export default __webpack_public_path__ + "static/media/sea_05.6df6920c2f90407cc4d6cab15d673885.svg";
export { ForwardRef as ReactComponent };